

import axios from 'axios';

import envManager from '../../com/envManager/EnvManager';

import { ActionType } from '../actionTypes';
import { Action } from '../actions';

import { Dispatch } from 'redux';


import { RegisterDto, LoginDto, ForgotPasswordDto, UserDto, ResetPasswordDto, ErrorDtoFactory } from '../../dtos';

export const logout = () => {

    return async (dispatch: Dispatch<Action>) => {
        dispatch({ type: ActionType.LOG_OUT });
    }

}

export const register = (registerDto: RegisterDto) => {

    return async (dispatch: Dispatch<Action>) => {
        
        dispatch({
            type: ActionType.REGISTER_START
        })
        
        try
        {
            let result = await axios.post(`${envManager.flyerEditorServerAddress}/api/auth/register`, registerDto)
            let data = result.data.data;

            let userDto:UserDto = { ...data } 
            // localStorage.setItem('userDto', JSON.stringify(userDto))

            dispatch({
                type: ActionType.REGISTER_SUCCESS,
                payload: userDto
            })

            dispatch({
                type: ActionType.REGISTER_COMPLETED,
            })
        } 
        catch(err){

            dispatch({
                type: ActionType.REGISTER_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const login = (loginDto: LoginDto, isForPreview: boolean = false) => {
    return async (dispatch: Dispatch<Action>) => {
        
        dispatch({
            type: ActionType.LOGIN_START
        })

        try
        {
            let result = await axios.post(`${envManager.flyerEditorServerAddress}/api/auth/login`, loginDto)
            let data = result.data.data;
            let userDto:UserDto = { ...data }
            if(isForPreview){
                localStorage.setItem('userDtoForPreview', JSON.stringify(userDto))
            } else {
                localStorage.setItem('userDto', JSON.stringify(userDto))
            }

            dispatch({
                type: ActionType.LOGIN_SUCCESS,
                payload: userDto
            })

            dispatch({
                type: ActionType.LOGIN_COMPLETED,
            })
        } 
        catch(err){

            dispatch({
                type: ActionType.LOGIN_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const forgotPassword = (forgotPasswordDto: ForgotPasswordDto) => {

    return async (dispatch: Dispatch<Action>) => {
        
        dispatch({
            type: ActionType.FORGOT_PASSWORD_START
        })

        try
        {
            let result = await axios.post(`${envManager.flyerEditorServerAddress}/api/auth/forgotPassword`, forgotPasswordDto)
            let data = result.data.data;
            
            dispatch({
                type: ActionType.FORGOT_PASSWORD_SUCCESS,
                payload: null
            })

            dispatch({
                type: ActionType.FORGOT_PASSWORD_COMPLETED,
            })
        } 
        catch(err){

            dispatch({
                type: ActionType.FORGOT_PASSWORD_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const resetPassword = (resetPasswordDto: ResetPasswordDto) => {

    return async (dispatch: Dispatch<Action>) => {
        
        dispatch({
            type: ActionType.RESET_PASSWORD_START
        })

        try
        {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + resetPasswordDto.token
                }
            }

            let result = await axios.post(`${envManager.flyerEditorServerAddress}/api/auth/resetPassword`, resetPasswordDto, config)
            let data = result.data.data;

            dispatch({
                type: ActionType.RESET_PASSWORD_SUCCESS,
                payload: null
            })

            dispatch({
                type: ActionType.RESET_PASSWORD_COMPLETED,
                payload: null
            })
        } 
        catch(err){
            dispatch({
                type: ActionType.RESET_PASSWORD_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const fetchUserData = (userDto: UserDto) => {

    return async (dispatch: Dispatch<Action>) => {
        
        dispatch({
            type: ActionType.FETCH_USER_DATA_START
        })

        try
        {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            let result = await axios.post(`${envManager.flyerEditorServerAddress}/api/auth/user/`, userDto, config);
            let data = result.data.data;
            
            let updatedUserDto:UserDto = {
                token: data.token,
                userId: data.userId,
                accountTier: data.accountTier,
                firstName: data.firstName,
                lastName: data.lastName,
                company: data.company,
                emailAddress: data.emailAddress,
                // userName: data.userName,
            } 

            dispatch({
                type: ActionType.FETCH_USER_DATA_SUCCESS,
                payload: updatedUserDto
            })

            dispatch({
                type: ActionType.FETCH_USER_DATA_COMPLETED,
                payload: updatedUserDto
            })
        } 
        catch(err){
            dispatch({
                type: ActionType.FETCH_USER_DATA_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const confirmEmail = (userId: number, token: string, isSaveUserDto: boolean = true) => {

    return async (dispatch: Dispatch<Action>) => {
        
        try{
            dispatch({
                type: ActionType.CONFIRM_EMAIL_START
            })

            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }
            let url = `${envManager.flyerEditorServerAddress}/api/auth/confirmEmail/${userId}/${token}`
            let result = await axios.post(url, {}, config);
            let data = result.data.data;
            localStorage.removeItem('userDto');
            let userDto:UserDto = { ...data }
            if(isSaveUserDto){
                localStorage.setItem('userDto', JSON.stringify(userDto))
                localStorage.setItem(`userEnterForFirstTime${userDto.userId}`, "true");
            }

            dispatch({
                type: ActionType.CONFIRM_EMAIL_SUCCESS,
                payload: userDto
            })

            dispatch({
                type: ActionType.CONFIRM_EMAIL_COMPLETED,
            })
        } 
        catch(err){
            dispatch({
                type: ActionType.CONFIRM_EMAIL_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }

    }
}